import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { OPEN_PAYMENT_POPOVER } from 'rich-text-lib/constants/usageTracking';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import InsertMenu from './InsertMenu';
import editorCapabilities from '../../editorCapabilities';
import InsertVideo from '../../commands/InsertVideo';
import { Tracker } from '../../../utils/usageTracker';
import { PM_PAYMENT } from '../../constants/events';
import useDebouncedEditorStateContext from '../../contexts/useDebouncedEditorStateContext';
import { insertContent } from '../../utils/documentUtils';
import { findNode } from '../../utils/nodeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function InsertMenuContainer({
  editorConfig,
  insertTypeOrder,
  onOpen
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const [open, setOpen] = useState(false);
  const [selectedType, setSelectedType] = useState('');
  const handleViewInsertMenu = useCallback(e => {
    e.stopPropagation();
    setSelectedType('');
  }, [setSelectedType]);
  const handleSelectType = useCallback(type => {
    setSelectedType(type);
    switch (type) {
      case editorCapabilities.PAYMENT_LINK:
        Tracker.track(PM_PAYMENT, {
          action: OPEN_PAYMENT_POPOVER
        });
        break;
      case editorCapabilities.SIGNATURE:
        {
          setOpen(false);
          if (!editorConfig.SIGNATURE) {
            Raven.captureException(new Error(`SELECTED_TYPE_UNKNOWN`), {
              extra: {
                type
              }
            });
            break;
          }
          if (editorConfig.SIGNATURE.signature && !findNode(editorState.doc, n => n.type.name === 'signature')) {
            const newState = insertContent({
              htmlBody: `<div data-hs-signature="true" >${editorConfig.SIGNATURE.signature}</div>`,
              editorState,
              from: editorState.tr.doc.content.size,
              to: editorState.tr.doc.content.size
            });
            setEditorState(newState);
          } else {
            editorConfig.SIGNATURE.showSignatureEditor();
          }
          break;
        }
      default:
        break;
    }
  }, [editorConfig.SIGNATURE, editorState, setEditorState]);
  const handleOpenChange = useCallback(({
    target: {
      value
    }
  }) => {
    setOpen(value);
    if (value && onOpen) {
      onOpen();
    }
  }, [setOpen, onOpen]);
  const handleDropdownOpenStart = useCallback(() => {
    setSelectedType('');
  }, [setSelectedType]);
  const handleCloseModal = useCallback(() => {
    setSelectedType('');
  }, [setSelectedType]);
  const handleInsertComplete = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const renderContent = () => /*#__PURE__*/_jsx(InsertMenu, {
    editorConfig: editorConfig,
    insertTypeOrder: insertTypeOrder
    // @ts-expect-error temp for migrating selectedType from string to InsertCapability
    ,
    selectedType: selectedType,
    handleSelectType: handleSelectType,
    handleViewInsertMenu: handleViewInsertMenu,
    handleInsertComplete: handleInsertComplete
  });
  const renderModal = () => {
    if (selectedType === editorCapabilities.VIDEO_INSERTION && editorConfig.VIDEO_INSERTION) {
      const entry = editorConfig.VIDEO_INSERTION;
      return /*#__PURE__*/_jsx(InsertVideo, {
        objectType: entry.objectType,
        recipientEmail: entry.recipientEmail,
        closeModal: handleCloseModal,
        onInsertComplete: handleInsertComplete,
        useInsertMenuVersion: true
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "transparent",
      closeOnMenuClick: false,
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.buttons.insertMenu"
      }),
      menuWidth: 400,
      placement: "top right",
      open: open,
      onOpenStart: handleDropdownOpenStart,
      onOpenChange: handleOpenChange,
      Content: renderContent
    }), renderModal()]
  });
}